<template>
  <div class="pay-success" ref="screenshotDOM">
    <van-dialog v-model="show" title="长按图片保存" :showConfirmButton="false" show-cancel-button>
      <img :src="picUrl" style="width: 280px;height: 480px;"/>
    </van-dialog>
    <div v-if="!isSuccess" class="pay-wc-text">订单生成中</div>
    <div v-else class="pay-wc-text">支付完成</div>
    <img src="@/assets/payH5/pay-success.png">
    <div v-if="isSuccess" class="pay-success-text">支付成功！</div>
    <div class="success-info">
      <template v-if="isSuccess">
        <div class="money">￥{{ realFee }}</div>
        <div class="wc-text">您已完成申领缴费，学生证将会依序下发</div>
        <div class="line"></div>
        <div class="info">
          <div class="info-left">孩子姓名</div>
          <div class="info-right">{{ studentName }}</div>
        </div>
        <div class="info">
          <div class="info-left">手机号码</div>
          <div class="info-right">{{ phone }}</div>
        </div>
        <div class="info">
          <div class="info-left">订单号</div>
          <div class="info-right">{{ orderId }}</div>
        </div>
        <div class="info">
          <div class="info-left">交易流水号</div>
          <div class="info-right">{{ tradeNo }}</div>
        </div>
        <div v-show="showbtn" class="save-img" @click="handleScreenshot">生成截图</div>
      </template>
    </div>
  </div>
</template>

<script>
import {getOrderStatus} from "@/api/payH5";
import {drawToPic} from "@/utils/screenshot";

export default {
  name: "paySuccess",
  data() {
    return {
      isSuccess: false,
      timer: null,
      realFee: 0,
      studentName: "",
      phone: "",
      tradeNo: "",
      orderId: "",
      showbtn: true,
      picUrl: "",
      show: false
    }
  },
  mounted() {
    //支付宝
    let orderId = this.$route.query.orderId;
    if (orderId === '' || orderId === null || orderId === undefined) {
      //微信
      orderId = this.getQueryString('orderId')
    }
    this.loopOrderState(orderId)
    this.hideOptionMenu();
  },
  methods: {
    handleScreenshot() {
      let that = this;
      that.showbtn = false;
      this.$nextTick(() => {
        drawToPic(that.$refs.screenshotDOM).then(res => {
          that.show = true;
          that.picUrl = res;
        })
        setTimeout(() => {
          that.showbtn = true;
        }, 200)
      })
    },
    // 方案2
    loopOrderState(orderId) {
      let that = this;
      that.timer = setInterval(() => {
        getOrderStatus({
          orderId: orderId
        }).then(res => {
          if (res.content.orderStatus === 'success') {
            that.isSuccess = true;
            clearInterval(that.timer)
            //显示数据
            that.studentName = res.content.studentName;
            that.realFee = res.content.realFee;
            that.phone = res.content.phone;
            that.tradeNo = res.content.tradeNo;
            that.orderId = orderId;
          }
        })
      }, 1000)
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    hideOptionMenu() {
      let that = this;
      if (typeof WeixinJSBridge == 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', that.onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady)
          document.attachEvent('onWeixinJSBridgeReady', that.onBridgeReady)
        }
      } else {
        that.onBridgeReady()
      }
    },
    onBridgeReady() {
      WeixinJSBridge.call('hideOptionMenu');
    }
    // 方案1
    // queryStatus() {
    //   let that = this;
    //   clearTimeout(that.timer)
    //   getOrderStatus().then(res => {
    //     //未成
    //     if (res.payStatus === 0) {
    //       this.timer = setTimeout(() => {
    //         return that.queryStatus();
    //       }, 3000)
    //     }
    //     //成功
    //     if (res.payStatus === 1) {
    //       that.timer && clearTimeout(that.timer)
    //       //显示数据
    //     }
    //   })
    // },

  }
}
</script>

<style scoped lang="scss">
.pay-success {
  width: 100%;
  height: 100%;
  position: relative;
  background: linear-gradient(270deg, #2AD0B5 0%, #65E5D0 100%);
  text-align: center;

  .pay-wc-text {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 60px;
    height: 60px;
  }

  .pay-success-text {
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 60px;
    height: 60px;
  }

  img {
    width: 130px;
    height: 104px;
  }

  .success-info {
    position: absolute;
    height: calc(100% - 234px);
    width: 100%;
    background: #ffffff;
    bottom: 0;
    border-radius: 20px 20px 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    .save-img {
      width: 180px;
      height: 42px;
      line-height: 42px;
      border-radius: 21px;
      border: 1px solid #2AD0B5;
      font-size: 17px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2AD0B5;
      text-align: center;
      margin-top: 80px;
    }

    .money {
      font-size: 30px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222222;
      margin: 40px 0 20px 0;
    }

    .wc-text {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      margin-bottom: 40px;
    }

    .line {
      width: 85%;
      border-bottom: 1px #ccc solid;
    }

    .info {
      width: 85%;
      display: flex;
      justify-content: space-between;
      margin-top: 15px;

      .info-left {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        min-width: 100px;
        text-align: left;
      }

      .info-right {
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        word-break: break-all;
      }
    }
  }
}
</style>